export default __webpack_public_path__ + "assets/images/17124798a582673802125111d8f75cca.svg";